import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Search, Lightbulb, ArrowRight } from 'lucide-react';

interface SearchRecommendationsProps {
  recommendations: string[];
  onSearchRecommendation: (query: string) => void;
  originalQuestion: string;
  isLoading?: boolean;
  className?: string;
}

export const SearchRecommendations: React.FC<SearchRecommendationsProps> = ({
  recommendations,
  onSearchRecommendation,
  originalQuestion,
  isLoading = false,
  className = ''
}) => {
  const handleRecommendationClick = (recommendation: string) => {
    if (!isLoading) {
      onSearchRecommendation(recommendation);
    }
  };

  return (
    <Card className={`bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200 ${className}`}>
      <CardHeader className="pb-4">
        <CardTitle className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Search className="h-5 w-5 text-blue-600" />
          Không Tìm Thấy Kết Quả Trực Tiếp
        </CardTitle>
        <p className="text-sm text-gray-600 mt-2">
          Chúng tôi không thể tìm thấy thông tin cụ thể cho "{originalQuestion}". 
          Hãy thử các tìm kiếm liên quan sau đây:
        </p>
      </CardHeader>
      
      <CardContent className="space-y-3">
        <div className="flex items-center gap-2 mb-4">
          <Lightbulb className="h-4 w-4 text-yellow-600" />
          <span className="text-sm font-medium text-gray-700">Tìm kiếm được đề xuất:</span>
        </div>
        
        <div className="space-y-2">
          {recommendations.map((recommendation, index) => (
            <Button
              key={index}
              variant="outline"
              className="w-full justify-between text-left h-auto p-3 hover:bg-blue-50 hover:border-blue-300 transition-colors"
              onClick={() => handleRecommendationClick(recommendation)}
              disabled={isLoading}
            >
              <span className="text-sm text-gray-700 flex-1 text-left">
                {recommendation}
              </span>
              <ArrowRight className="h-4 w-4 text-gray-400 flex-shrink-0" />
            </Button>
          ))}
        </div>
        
        <div className="mt-6 pt-4 border-t border-blue-200">
          <p className="text-xs text-gray-500 text-center">
            💡 Mẹo: Hãy thử sử dụng từ khóa cụ thể hơn hoặc cách diễn đạt khác
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SearchRecommendations;